import { intl } from './intl';

export const { t: headerT, Message: HeaderMessage } = intl.createMessages({
    documentation: {
        ru: 'Документация',
        en: 'Documentation',
    },
    serviceInfo: {
        ru: 'Информация о сервисе',
        en: 'Service Information',
    },
    appName: {
        ru: 'Вжик',
        en: 'Vzhik',
    },
});
